import gql from "graphql-tag"

export const ShopifyMoneyV2Fields = gql`
  fragment ShopifyMoneyV2Fields on MoneyV2 {
    amount
    currencyCode
  }
`

export const ShopifyPricingPercentageValueFields = gql`
  fragment ShopifyPricingPercentageValueFields on PricingPercentageValue {
    percentage
  }
`

export const CartFields = gql`
  ${ShopifyMoneyV2Fields}
  fragment CartFields on Cart {
    id
    checkoutUrl
    buyerIdentity {
      countryCode
    }
    cost {
      subtotalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalAmount {
        ...ShopifyMoneyV2Fields
      }
      totalTaxAmount {
        ...ShopifyMoneyV2Fields
      }
      totalDutyAmount {
        ...ShopifyMoneyV2Fields
      }
    }
    discountCodes {
      applicable
      code
    }
    discountAllocations {
      __typename
      discountedAmount {
        ...ShopifyMoneyV2Fields
      }
      targetType
    }
    lines(first: 100) {
      edges {
        node {
          id
          quantity
          attributes {
            key
            value
          }
          cost {
            amountPerQuantity {
              ...ShopifyMoneyV2Fields
            }
            compareAtAmountPerQuantity {
              ...ShopifyMoneyV2Fields
            }
            subtotalAmount {
              ...ShopifyMoneyV2Fields
            }
            totalAmount {
              ...ShopifyMoneyV2Fields
            }
          }
          discountAllocations {
            __typename
            discountedAmount {
              ...ShopifyMoneyV2Fields
            }
            targetType
          }
          merchandise {
            ... on ProductVariant {
              id
              sku
              product {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`

export const CartUserErrorsFields = gql`
  fragment CartUserErrorsFields on CartUserError {
    code
    field
    message
  }
`

export const CustomerAccountFields = `
  fragment CustomerAccountFields on Customer {
    id
    firstName
    lastName
    displayName
    creationDate
    emailAddress {
      emailAddress
      marketingState
    }
    phoneNumber {
      phoneNumber
      marketingState
    }
    tags
    defaultAddress {
      id
      firstName
      lastName
      formatted
      address1
      address2
      city
      province
      country
      zip
      phoneNumber
    }
    addresses(first: 20) {
      nodes {
        id
        firstName
        lastName
        formatted
        address1
        address2
        city
        province
        country
        zip
        phoneNumber
      }
    }
    orders(first: 20, reverse: true) {
      nodes {
        id
        name
        processedAt
        discountApplications(first: 5) {
          nodes {
            value {
              ... on MoneyV2 {
                amount
                currencyCode
              }
              ... on PricingPercentageValue {
                percentage
              }
            }
          }
        }
        financialStatus
        fulfillmentStatus
        fulfillments(first: 20) {
          nodes {
            estimatedDeliveryAt
            latestShipmentStatus
            trackingInformation {
              company
              number
              url
            }
          }
        }
        shippingLine {
          originalPrice {
            amount
            currencyCode
          }
        }
        subtotal {
          amount
          currencyCode
        }
        totalTax {
          amount
          currencyCode
        }
        totalPrice {
          amount
          currencyCode
        }
        shippingAddress {
          address1
          address2
          city
          province
          country
          zip
        }
        lineItems(first: 100) {
          nodes {
            id
            title
            sku
            price {
              amount
              currencyCode
            }
            quantity
            variantId
            variantTitle
            customAttributes {
              key
              value
            }
          }
        }
      }
    }
  }
`

export const CustomerUserErrorsFields = gql`
  fragment CustomerUserErrorsFields on CustomerUserError {
    code
    field
    message
  }
`
// View: Order Status
export const OrderFields = gql`
  fragment OrderFields on Order {
    createdAt
    name
    email
    phone
    shippingAddress {
      firstName
      lastName
      address1
      address2
      zip
      city
      province
      provinceCode
      country
    }
    displayFulfillmentStatus
    fulfillments(first: 5) {
      deliveredAt
      displayStatus
      trackingInfo(first: 5) {
        number
        url
      }
    }
    lineItems(first: 10) {
      edges {
        node {
          quantity
          variant {
            id
            sku
            compareAtPrice
            price
            product {
              id
              title
            }
          }
          customAttributes {
            key
            value
          }
          discountAllocations {
            allocatedAmount {
              amount
            }
          }
        }
      }
    }
  }
`
